module.exports = __webpack_public_path__ + "img/pro-body-photo3.26fa5c93.png";